/**
 * Dev/test logging for purchase → dataLayer.
 * In browser console: window.__purchaseDebugLogs
 */
const LOG_PREFIX = '[GA][PURCHASE][TEST]';

export function logPurchaseDebug(stage, details = {}) {
    if (typeof window === 'undefined') {
        return;
    }

    if (!Array.isArray(window.__purchaseDebugLogs)) {
        window.__purchaseDebugLogs = [];
    }

    const entry = {
        at: new Date().toISOString(),
        stage,
        ...details,
    };

    window.__purchaseDebugLogs.push(entry);

    const isError = stage.includes('SKIP') || stage.includes('FAIL') || stage.includes('ERROR');
    const logger = isError ? console.warn : console.info;

    logger(`${LOG_PREFIX} ${stage}`, details);
}

export function installPurchaseDebugLogger() {
    if (typeof window === 'undefined') {
        return;
    }

    if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = [];
    }

    if (window.__purchaseDebugHookInstalled) {
        return;
    }

    const originalPush = window.dataLayer.push.bind(window.dataLayer);

    window.dataLayer.push = (...args) => {
        args.forEach((payload) => {
            if (!payload || payload.event !== 'purchase') {
                return;
            }

            logPurchaseDebug('DATALAYER_PUSH', {
                event: payload.event,
                transaction_id: payload.ecommerce?.transaction_id,
                value: payload.ecommerce?.value,
                currency: payload.ecommerce?.currency,
                itemsCount: payload.ecommerce?.items?.length ?? 0,
                payload,
            });

            console.groupCollapsed(`${LOG_PREFIX} ✅ purchase у dataLayer`);
            console.table({
                transaction_id: payload.ecommerce?.transaction_id,
                value: payload.ecommerce?.value,
                currency: payload.ecommerce?.currency,
                items: payload.ecommerce?.items?.length ?? 0,
            });
            console.log('Повний payload:', payload);
            console.groupEnd();
        });

        return originalPush(...args);
    };

    window.__purchaseDebugHookInstalled = true;

    logPurchaseDebug('HOOK_READY', {
        hint: 'Після success popup шукайте DATALAYER_PUSH або TRACKER_SENT. Логи: window.__purchaseDebugLogs',
    });
}
